// Run lifecycle bindings. Mirrors iOS RunsEndpoints + ActiveRunsStore against
// /runs/*. The poll-and-advance loop lives in create/use-run.ts.
import { api } from "./client";
import type { RunRead, StartInputs } from "./create-types";

export function startRun(frameworkSlug: string, startInputs: StartInputs): Promise<RunRead> {
  return api.post<RunRead>("/runs/", {
    framework_slug: frameworkSlug,
    start_inputs: startInputs,
  });
}

export function getRun(runId: string): Promise<RunRead> {
  return api.get<RunRead>(`/runs/${encodeURIComponent(runId)}`);
}

export function listRuns(): Promise<RunRead[]> {
  return api.get<RunRead[]>("/runs/");
}

export function advanceRun(
  runId: string,
  userResponse: Record<string, unknown>,
): Promise<RunRead> {
  return api.post<RunRead>(`/runs/${encodeURIComponent(runId)}/advance`, {
    user_response: userResponse,
  });
}

export function deleteRun(runId: string): Promise<void> {
  return api.delete<void>(`/runs/${encodeURIComponent(runId)}`);
}
